class AuthMenuCtrl {
  constructor(AuthService, EventService, $state, $rootScope, $scope, $window) {
    'ngInject';
    this.as = AuthService;
    this.es = EventService;
    this.$state = $state;
    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.$window = $window;
  }

  $onInit() {
    this.loadMessages();
    this.$scope.$watch('$root.userMessages', () => {
      this.loadMessages();
    });
  }

  loadMessages() {
    const messages = this.$rootScope["userMessages"];
    this.messageCount = messages?.list?.filter(m => m.type != 'Banner').length || 0;
  }

  showMessages() {
    if (!this.messageCount) return;
    this.es.dispatchEvent(this.es.actions.USER_MESSAGE_SELECTED, { messageId: null } );
  }

  getUsageReport() {
    const realmId = this.$rootScope["realmId"];
    const rids = {"d8814105-57d1-4d56-b488-5b7cbdac8af9": realmId};
    const feProdTemplateId = "571d596d-adb3-4b13-b2dd-570a75b9965a";
    // The template and Quick Base viewer are FE production-only, even when the UI runs in another environment.
    const pdfUrl = `https://api.formengine.com/genFromId?templateId=${feProdTemplateId}&action=print&rids=${encodeURIComponent(JSON.stringify(rids))}`;
    const viewerUrl = "https://advantageintegratedsolutionsinc.quickbase.com/db/bmvbhkvyy?a=dbpage&pageID=20&pdfUrl=" + encodeURIComponent(pdfUrl);
    this.$window.open(viewerUrl, "_blank");
  }

  async logout() {
    this.as.logout();
  }

}

export default {
  bindings: {
    user: "<"
  },
  templateUrl: "user/auth-menu/auth-menu.component.html",
  controller: AuthMenuCtrl
}
